import React, { useState } from "react";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import { Loading } from "@atoms/Loading";
import styles from "./calendly.module.scss";

// Formulario de demo embebido (Pipedrive Webforms, uno por idioma).
// El tracking de conversión se hace en /schedule-demo/thanks, a donde
// redirige el form de Pipedrive al enviarse.
const Calendly = () => {
  const { t } = useTranslation();
  const { language } = useI18next();
  const [loaded, setLoaded] = useState(false);
  const lang = language === "pr" ? "pt" : language;

  const urlForm = lang == "es" ? "https://webforms.pipedrive.com/f/2TBEx7cIUk0v1ZUb02egcHPpoG1ptideEm5j0W6ORrsWr9eYh1plvUY8AF0a5YOwX" :
              lang == "en" ? "https://webforms.pipedrive.com/f/1ysQeUmsoysgu04P8OSG5k9XZUyxCxSUDGWiGtMTkzTaGh2aCKv4dSLmvHV3p13Hl" :
              "https://webforms.pipedrive.com/f/1GcvKuyqMxBY1ZV0xKYEiEGMpl1vc0sb4TBY8d5KIufEralmwlZ2iSPMJiJNcsT2r";

  return (
    <div className={styles.container}>
      <div className="container">
        <div className={styles.div__notview_logopipedrive}></div>
      </div>
      <div className={styles.divForm}>
        {!loaded && (
          <div className={styles.loading}>
            <Loading size={48} label={t("SCHEDULE_DEMO.LOADING")} />
          </div>
        )}
        <iframe
          title="Schedule demo form"
          src={urlForm}
          onLoad={() => setLoaded(true)}
        ></iframe>
      </div>
    </div>
  );
};

export default Calendly;
